import { render, staticRenderFns } from "./MandatePreviewDocument.vue?vue&type=template&id=66e9a18f"
import script from "./MandatePreviewDocument.vue?vue&type=script&lang=ts"
export * from "./MandatePreviewDocument.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports